whenAvailable('$',function() {
$(function () {
    // SLICK
    whenAvailable('slick',function() {
        

        $('#logosCarousel')?.slick({
            infinite: false,
            arrows: true,
            prevArrow: '<div class="arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z" fill="#888888" fill-rule="evenodd"/></svg><span>See More</span></div>',
            nextArrow: '<div class="arrow-next"><span>See More</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z" fill="#888888" fill-rule="evenodd"/></svg></div>',
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                    focusOnSelect: true,
                    arrows: false,
                }
            }]
        });
        
        function initSlickRevolving(){            
            
            let slick_intialized_reviewsCarousel = $('#reviewsCarousel.slick-revolving').hasClass('slick-initialized');
            if ( !slick_intialized_reviewsCarousel) {
                    $('#reviewsCarousel')?.slick({
                    mobileFirst: true,
                    infinite: false,
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                centerPadding: 'calc(100vw / 8)',
                                slidesToShow: 2.5,
                                slidesToScroll: 1,                        
                                centerMode: false,
                                dots: false,
                            },
                        },
                        {
                            breakpoint: 1400,
                            settings: {
                                centerPadding: 'calc(100vw / 7)',
                                slidesToShow: 3,
                                slidesToScroll: 1,                        
                                centerMode: false,
                                arrows: true,
                                dots: true,
                                infinite: true,
                                prevArrow: '<div class="arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z" fill="#888888" fill-rule="evenodd"/></svg></div>',
                                nextArrow: '<div class="arrow-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z" fill="#888888" fill-rule="evenodd"/></svg></div>',
                            },                           
                        }
                    ]
                });
            }
            let slick_intialized_featured_products = $('#featured_products.slick-revolving').hasClass('slick-initialized');
            if ( !slick_intialized_featured_products) {
                    $('#featured_products')?.slick({
                    mobileFirst: true,
                    infinite: false,
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,                        
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 1500,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1,  
                                dots: false,                      
                                arrows: true,
                                prevArrow: '<div class="arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z" fill="#888888" fill-rule="evenodd"/></svg></div>',
                                nextArrow: '<div class="arrow-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z" fill="#888888" fill-rule="evenodd"/></svg></div>',
                    
                            },                           
                        }
                    ]
                });
            }          
            
        }

            

        initSlickRevolving();
        $(window).on( "resize", function() {
                initSlickRevolving();
                
        });  
        
    });
    

    // COUNTRY DROPDOWN
    const this_store = $('body').attr('data-store-code');

    $.each(store_country[this_store], function (k, v) {
        $('#contact_country').append('<option value="'+country_list[v]+'">'+country_list[v]+'</option>');
    });
    $.each(country_list, function (k, v) {
        $('#contact_country').append('<option value="'+v+'">'+v+'</option>');
    });

    // KR checkbox
    if ($('.terms-kr').length > 0) {
        let checkboxTarget = '.terms-kr .field.stack';
        $(checkboxTarget).change(function() {
            if ($(this).hasClass('all')) {
                if ($(checkboxTarget + '.all .input-checkbox')[0].checked) { $(checkboxTarget + '.single .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.single .input-checkbox').prop('checked', false); }
            } else {
                var allChecked = true;
                $(checkboxTarget + '.single .input-checkbox').each(function(i,v) { if (!this.checked) { allChecked = false; } });
                if (allChecked == true) { $(checkboxTarget + '.all .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.all .input-checkbox').prop('checked', false); }
            }
        });
    }

    const $submit_button = $('#form_submit'),
          $main_form = $('#external_order_form'),
          cisElement = document.getElementById('contact_inquiry_source'),
          cisContainer = document.getElementsByClassName('contact_inquiry_source_container')[0],
          cisOthersValue = "Others";

    cisElement?.addEventListener("change", (e) => {
        const toggleValue = 'invisible'

        if(e.target.value === cisOthersValue)  cisContainer?.classList.remove(toggleValue)
        else cisContainer?.classList.add(toggleValue)
    })

    $submit_button.on('click', function(){ 
        const cisValue = cisElement?.value
        const cisoElement = document.getElementById('contact_inquiry_source_others');

        // contact_inquiry_source required or not logic
        if(cisValue === cisOthersValue) cisoElement?.setAttribute("required", true)
        else cisoElement?.removeAttribute("required")
        
        $.validateForm('#external_order_form'); 
        validateCheckbox();

        if($('#product_type_checkbox').length > 0) {
            if ($('input[name="product_type[]"]:checked').length === 0) {
                event.preventDefault(); // Prevent the form from submitting
                return;
            } else {
                $('#product_type_checkbox').prop('checked', true);
            }
        }

        // Validation of field on field change/keyup after form was validated
        $('body').on('change', '.checkbox-data', function(){
            validateCheckbox();
        });
    });

    
    function validateCheckbox() {
        let checkboxChecked = false;
        $('.checkbox-data').each(function(){
            const $checkboxWrapper = $(this).parent();
            if ($(this).is(':checked')) {
                $checkboxWrapper.removeClass('is-invalid');
                $checkboxWrapper.siblings('.form-check-label').removeClass('is-invalid');
                $('.form-check-label').removeClass('is-invalid');
                checkboxChecked = true;
            } else {
                if(checkboxChecked) return;
                $checkboxWrapper.addClass('is-invalid');
                $checkboxWrapper.siblings('.form-check-label').addClass('is-invalid');
            }
        });

        if (checkboxChecked) {
            $('#wrapper_terms .invalid-feedback').hide();
        } else {
            $('#wrapper_terms .invalid-feedback').show();
        }
        return checkboxChecked;
    }

    $main_form.submit(function (e) {
        e.preventDefault();
        const formData = new FormData(this);
        const cisFinalValue = formData.get("contact_inquiry_source");

        if(cisFinalValue === cisOthersValue) {
            const otherValue = formData.get("contact_inquiry_source_others")
            formData.set("contact_inquiry_source", `${cisFinalValue} - ${otherValue}`)
        }

        formData.delete("contact_inquiry_source_others")
        formData.append('from_store', this_store);
        formData.append('form_agree_terms', 1);
            
        const isValid = validateCheckbox();

        const formType = formData.get("form_type");
        if(formType == 'Frasers Property' && !isValid) {
            return;
        }

        return $.submitForm('https://beans.secretlab.co/index.php/api/submit_order_form', formData, $main_form);
        
    });
});
});